import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

import { isPosShopRestricted } from "../core/retailShop.core";
import useGetRetailShopId from "./useGetRetailShopId.hook";

export default function useRestrictionCheck() {
  const router = useRouter();
  const retailShopId = useGetRetailShopId();
  const [redirected, setRedirected] = useState(false);

  const { data, isLoading } = useQuery({
    queryKey: ["restrictionCheck", retailShopId],
    queryFn: () => {
      if (!retailShopId) return null;
      return isPosShopRestricted(retailShopId);
    },
    enabled: !!retailShopId,
    refetchInterval: 60000,
  });

  useEffect(() => {
    if (redirected) return;
    if (isLoading) return;
    if (!data) return;

    if (data.isRestrictedBool) {
      setRedirected(true);
      router.push("/restricted");
    } else {
      if (router.pathname === "/restricted") {
        setRedirected(true);
        router.push("/");
      }
    }
  }, [data, isLoading, router, redirected]);

  return {
    isRestricted: data?.isRestrictedBool ?? false,
    reason: data?.reason ?? null,
    clientIp: data?.clientIp,
    isLoading,
  };
}
